module.exports = __webpack_public_path__ + "static/media/product2.7fbe5df1.jpg";